// class DetailsDisclosure extends HTMLElement {
//   constructor() {
//     super();
//     this.mainDetailsToggle = this.querySelector('details');
//     this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

//     this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
//     this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
//   }

//   onFocusOut() {
//     setTimeout(() => {
//       if (!this.contains(document.activeElement)) this.close();
//     });
//   }

//   onToggle() {
//     if (!this.animations) this.animations = this.content.getAnimations();

//     if (this.mainDetailsToggle.hasAttribute('open')) {
//       this.animations.forEach((animation) => animation.play());
//     } else {
//       this.animations.forEach((animation) => animation.cancel());
//     }
//   }

//   close() {
//     this.mainDetailsToggle.removeAttribute('open');
//     this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
//   }
// }

// customElements.define('details-disclosure', DetailsDisclosure);

// class HeaderMenu extends DetailsDisclosure {
//   constructor() {
//     super();
//     this.header = document.querySelector('.header-wrapper');
//   }

//   onToggle() {
//     if (!this.header) return;
//     this.header.preventHide = this.mainDetailsToggle.open;

//     if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
//     document.documentElement.style.setProperty(
//       '--header-bottom-position-desktop',
//       `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
//     );
//   }
// }

// customElements.define('header-menu', HeaderMenu);

class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.content = this.summary.nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.summary.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.mainDetailsToggle.addEventListener('mouseleave', this.onMouseLeave.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onMouseEnter() {
    this.open();
  }

  onMouseLeave() {
    this.close();
  }

  open() {
    this.mainDetailsToggle.setAttribute('open', '');
    this.summary.setAttribute('aria-expanded', true);

    if (!this.animations) this.animations = this.content.getAnimations();
    this.animations.forEach((animation) => animation.play());
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.summary.setAttribute('aria-expanded', false);

    if (this.animations) {
      this.animations.forEach((animation) => animation.cancel());
    }
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  open() {
    super.open();

    if (this.header) {
      this.header.preventHide = true;

      // Set the CSS variable only if it's not already set
      if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') === '') {
        document.documentElement.style.setProperty(
          '--header-bottom-position-desktop',
          `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
        );
      }
    }
  }

  close() {
    super.close();
    if (this.header) {
      this.header.preventHide = false;
    }
  }
}

customElements.define('header-menu', HeaderMenu);
